export default "<div>\n  <a href=\"javascript:void(0);\" (click)=\"connectBankAccount()\" class=\"btn btn-primary\">Connect Bank Account</a>\n</div>\n"